module.exports = __webpack_public_path__ + "static/img/no-internet.4fc3be75.svg";